export const classes = {
  wrapper: 'w-[250px]',
  card: 'place-between w-full shadow-dialog',
  icon: 'text-green-3',
  message: 'ml-3 text-grey-8 dark:text-mauve-1 text-base',
};
